<template lang="pug">
  .dashboard-view
    v-container.pa-0.mb-8(style="max-width:600px")
      div.pa-4.mt-4.mx-6(style="border:1px solid var(--v-basic300); border-radius: 4px;")
        div.s2.primary400--text Earnings
        v-layout.pa-6(v-if="isFetchingEarnings")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          div.px-3.pt-3(v-if="earnings")
            div.h2.success500--text {{ earnings.this_month_earnings | displayPrice }}
            div.c2.primary400--text earned this month
            div.mt-3.d-flex.align-center
              div.p2.basic800--text To be paid this month
              v-spacer
              div.s2.basic800--text {{ earnings.this_month_payout | displayPrice }}
            div.mt-1.d-flex.align-center
              div.p2.basic800--text Life time earnings
              v-spacer
              div.s2.basic800--text {{ earnings.lifetime_earnings | displayPrice }}
            div.mt-1.d-flex.align-center
              div.p2.basic800--text Potential earnings
              v-spacer
              div.s2.basic800--text {{ earnings.potential_earnings | displayPrice }}
          div.c1.text-center(v-else) No data
      div.py-4.mt-6.mx-6(style="border:1px solid var(--v-basic300); border-radius: 4px;")
        div.h6.primary500--text.px-4 Stats & Insight
        v-layout.pa-6(v-if="isFetchingStats")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          v-row.my-3.mx-5(v-if="stats && !stats.to_maintain_record" no-gutters justify="center" align="center" style="border:1px solid var(--v-info100); border-radius: 4px;")
            v-col.py-3(cols="3")
              div.h5.basic700--text.text-center {{ stats.to_maintain_record }}
            v-col.py-3(cols="7")
              div.c1.basic600--text New merchants to maintain last month’s record
          div.my-2
            affiliate-chart(:propAffiliate="affiliate")
          template(v-if="stats")
            v-divider.basic300
            div.px-7
              div.mt-3.d-flex.align-center
                div.p2.basic800--text Total merchants (All-time)
                v-spacer
                div.s2.basic800--text {{ stats.all_time_merchants }}
              div.mt-1.d-flex.align-center
                div.p2.basic800--text Total merchants (This month)
                v-spacer
                div.s2.basic800--text {{ stats.this_month_merchants }}
              div.mt-1.d-flex.align-center
                div.p2.basic800--text Merchants in trial
                v-spacer
                div.s2.basic800--text {{ stats.merchants_in_trial }}
          div.c1.text-center(v-else) No data
      div.py-4.mt-6.mx-6(style="border:1px solid var(--v-basic300); border-radius: 4px;")
        div.h6.primary500--text.px-4 Top 5 Ranking {{ ranks ? ranks.month : '' }}
        v-layout.pa-6(v-if="isFetchingRanks")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          template(v-if="ranks")
            div.mt-4
              v-row.py-2(v-for="(rank, idx) in ranks.top5" :key="idx" no-gutters align="center" :style="rank.slug === ranks.myinfo.slug ? 'background-color: var(--v-info500);' : ''")
                v-col.px-4.shrink
                  div.s1.text-center(:class="rank.slug === ranks.myinfo.slug ? 'basic100--text' : 'basic800--text'") {{ idx + 1 }}
                v-col(cols="2")
                  v-avatar
                    v-img(:src="rank.image ? rank.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
                v-col.px-4
                  div.s1(:class="rank.slug === ranks.myinfo.slug ? 'basic100--text' : 'basic800--text'") {{ rank.first_name }} {{ rank.last_name }} {{ rank.slug === ranks.myinfo.slug ? '(You)' : '' }}
              v-row.py-2(v-if="ranks.myrank > 5" no-gutters align="center" style="background-color: var(--v-info500);")
                v-col.px-4.shrink
                  div.s1.basic100--text.text-center {{ ranks.myrank }}
                v-col(cols="2")
                   v-avatar
                    v-img(:src="ranks.myinfo.image ? ranks.myinfo.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
                v-col.px-4
                  div.s1.basic100--text {{ ranks.myinfo.first_name }} {{ ranks.myinfo.last_name }} (You)
            div.mt-2.c1.basic600--text.text-center(v-if="ranks.remarks && ranks.remarks.to_top") Get 
              strong.primary--text {{ ranks.remarks.merchant_number }} 
              | more merchants to get top to {{ ranks.remarks.to_top }} ranking
          div.c1.text-center(v-else) No data
      div.pa-4.mt-6.mx-6(style="border:1px solid var(--v-basic300); border-radius: 4px;")
        div.d-flex.align-center
          div.h6.primary500--text.px-4 Your link
          v-spacer
          v-menu(:offset-y='true')
            template(v-slot:activator='{ on }')
              v-btn.button-AA-small.text-capitalize(color="primary" outlined small v-on="on")
                | {{ software }}
                v-icon.ml-1(small color="primary" right style="margin-top: 2px;") mdi-chevron-down
            v-list(dense)
              v-list-item(@click="software = 'storefront'")
                v-list-item-title.s2.basic800--text Storefront
              v-list-item(@click="software = 'clinic'")
                v-list-item-title.s2.basic800--text Clinic
              v-list-item(@click="software = 'donation'")
                v-list-item-title.s2.basic800--text Donation
              v-list-item(@click="software = 'review'")
                v-list-item-title.s2.basic800--text Review
        v-text-field.my-2(v-model="affiliate.slug + (software !== 'storefront' ? `?os=${software}` : '')" background-color="basic200" height="40" outlined dense placeholder="custom_link" :prefix="`https://yezza.link/`" hide-details="auto" readonly)
        a.c1.info400--text(@click="showGenerateLink = true") Generate new link here
        div.mt-3.d-flex.align-center
          v-spacer
          v-btn.button-AA-small(color="info500" outlined small height="32" style="background-color: var(--v-infoT08);" @click="copyUrl" v-clipboard:copy="getShareLink()") copy
          v-btn.button-AA-small.ml-2(color="info500" dark depressed small height="32" @click="shareSheet = true") share
      div.pa-4.mt-6.mx-6(style="border:1px solid var(--v-basic300); border-radius: 4px;")
        v-layout.pa-6(v-if="isFetchingStats")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          template(v-if="stats")
            div.h6.primary500--text.px-4 Merchants ({{ stats.all_time_merchants }})
            div.mt-4
              v-row.py-2(v-for="(merc, idx) in stats.affiliate_merchants" :key="idx" no-gutters align="center")
                v-col(cols="2")
                  v-avatar
                    v-img(:src="merc.logo ? merc.logo.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
                v-col.pl-4
                  div.s1.basic800--text {{ merc.name }}
                  div.d-flex.align-center.mt-1(v-if="merc.earned")
                    div.p2.primary400--text(v-if="merc.earned.amount") Earned {{ merc.earned.amount }}
                    v-spacer
                    div.p2.primary400--text(v-if="merc.earned.paid_at") {{ merc.earned.paid_at | humanizeDate }}
            v-btn.button-AA-small.mt-4(v-if="stats.all_time_merchants > 5" color="info500" dark depressed small block height="32" @click="showMerchants = true") See all merchants ({{ stats.all_time_merchants }})
          div.c1.text-center(v-else) No data

      .modal
        show-all-merchants(v-if="showMerchants" :open.sync="showMerchants" :propAffiliate="affiliate")
        generate-affiliate-link(v-if="showGenerateLink" :open.sync="showGenerateLink" :propAffiliate.sync="affiliate")
        y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
          v-card.py-4(flat)
            div.mx-6.s2.primary400--text Share url by
            v-list.pa-0
              v-list-item(@click="shareUrlToSocial('whatsapp')")
                v-list-item-avatar.my-0
                  v-icon(color="#455A64" size="24") fab fa-whatsapp
                v-list-item-title.s2.basic1000--text WhatsApp
              v-list-item(@click="shareUrlToSocial('facebook')")
                v-list-item-avatar.my-0
                  v-icon(color="#3b5998" size="24") fab fa-facebook
                v-list-item-title.s2.basic1000--text Facebook
</template>

<script>
import { mapActions } from 'vuex'
import ShowAllMerchants from '@/components/dialogs/affiliate/ShowAllMerchants.vue'
import GenerateAffiliateLink from '@/components/dialogs/affiliate/GenerateAffiliateLink.vue'
import AffiliateChart from '@/components/analytics/AffiliateChart.vue'

export default {
  name: 'AffiliateDashboard',
  components: { ShowAllMerchants, GenerateAffiliateLink, AffiliateChart },
  props: ['propAffiliate'],
  data: () => ({
    isLoading: false,
    isFetchingEarnings: false,
    isFetchingStats: false,
    isFetchingRanks: false,
    isFetchingCharts: false,
    showMerchants: false,
    showGenerateLink: false,
    earnings: null,
    stats: null,
    ranks: null,
    charts: null,
    software: 'storefront',
    shareSheet: false
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
  },
  mounted () {
    this.fetchEarnings()
    this.fetchStats()
    this.fetchRanks()
    // this.affiliateSlug = this.affiliate.slug
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchEarnings () {
      this.isFetchingEarnings = true
      this.$axios.get('/partners/earnings?type=yezza')
        .then(resp => {
          this.earnings = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingEarnings = false
        })
    },
    fetchStats () {
      this.isFetchingStats = true
      this.$axios.get(`/partners/stats`)
        .then(resp => {
          this.stats = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingStats = false
        })
    },
    fetchRanks () {
      this.isFetchingRanks = true
      this.$axios.get(`/partners/ranks`)
        .then(resp => {
          this.ranks = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingRanks = false
        })
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    getShareLink () {
      if (this.software !== 'storefront') {
        return `https://yezza.link/${this.affiliate.slug}?os=${this.software}`
      }
      return `https://yezza.link/${this.affiliate.slug}`
    },
    shareUrlToWA() {
      window.open(`https://api.whatsapp.com/send?text=${this.getShareLink()}&phone=${this.lead.phone}`)
    },
    shareUrlToSocial(platform) {
      console.log(platform)
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLink()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLink()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLink())}`, '_blank')
      }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>